import { component } from 'vue-form-generator';
// import 'vue-form-generator/dist/vfg.css';

import customObjectData from '@/data/custom-object-schema';

export default {
  name: 'PanelItemSidebar',

  components: {
    VueFormGenerator: component,
  },

  data() {
    return {
      customObject: {
        model: customObjectData.model,
        schema: customObjectData.schema,
        formOptions: customObjectData.formOptions,
      },
    };
  },

};
